module.exports = __webpack_public_path__ + "media/images/lb/467-7ba652938f8aaae36af105c7ad4e79ae.svg";